export const FiberLengthLossEnum = {

SFPType: [
 { key: 0, value: "dual_fiber" },
 { key: 1, value: "single_fiber" }
],

FiberType: [
   { key: 0, value: "OM1" },
   { key: 1, value: "OM2" },
   { key: 2, value: "OM3" },
   { key: 3, value: "OM4" },
   { key: 4, value: "OM5" },
   { key: 5, value: "OS1" },
   { key: 6, value: "OS2" }
],

TestDirection: [
   { key: 0, value: "fiber_test_unidir" },
   { key: 1, value: "fiber_test_bidir" }
],

TestMethod: [
   { key: 0, value: "one_jumper" },
   { key: 1, value: "two_jumper" },
   { key: 2, value: "three_jumper" }
],

ConnectorType: [
   { key: 0, value: "LC" },
   { key: 1, value: "SC" },
   { key: 2, value: "FC" },
   { key: 3, value: "ST" },
   { key: 4, value: "LX5" },
   { key: 5, value: "MU" },
   { key: 6, value: "LSH (E2000)" },
   { key: 7, value: "MT-RJ" },
   { key: 8, value: "Optic (Jack)" }
],

LimitType: [
   { key: 0, value: "none_constant" },
   { key: 1, value: "test_standard_custom" },
   { key: 2, value: "100BASE-FX" },
   { key: 3, value: "1000BASE-LX" },
   { key: 4, value: "1000BASE-SX" },
   { key: 5, value: "10GBASE-LX4" },
   { key: 6, value: "10GBASE-E" },
   { key: 7, value: "10GBASE-L" },
   { key: 8, value: "10GBASE-S" },
   { key: 9, value: "40GBASE-LR4" },
   { key: 10, value: "40GBASE-SR4" },
   { key: 11, value: "100GBASE-LR4" },
   { key: 12, value: "100GBASE-SR4" },
   { key: 13, value: "100GBASE-SR10" },
   { key: 14, value: "1000BASE-EX" },
   { key: 15, value: "1000BASE-LX10" },
   { key: 16, value: "1000BASE-ZX" }
],

RefractiveIndexForFiberType: [
   { key: 0, value: 1.49350 },
   { key: 1, value: 1.47950 },
   { key: 2, value: 1.48100 },
   { key: 3, value: 1.48100 },
   { key: 4, value: 1.48100 },
   { key: 5, value: 1.46650 },
   { key: 6, value: 1.46750 }
],

LimitsForFiberType: [
   { key: 0, value: [
      {limit: 0, wavelength: 0, lengthlimit: 0, losslimit: 0},
      {limit: 1, wavelength: 0, lengthlimit: 0, losslimit: 0},
      {limit: 2, wavelength: 1300, lengthlimit: 2000, losslimit: 11.0},
      {limit: 3, wavelength: 1300, lengthlimit: 550, losslimit: 2.3},
      {limit: 4, wavelength: 850, lengthlimit: 275, losslimit: 2.6},
      {limit: 5, wavelength: 1300, lengthlimit: 300, losslimit: 2.5},
   ] }, // OM1

   { key: 1, value: [
      {limit: 0, wavelength: 0, lengthlimit: 0, losslimit: 0},
      {limit: 1, wavelength: 0, lengthlimit: 0, losslimit: 0},
      {limit: 2, wavelength: 1300, lengthlimit: 2000, losslimit: 11.0},
      {limit: 3, wavelength: 1300, lengthlimit: 550, losslimit: 2.3},
      {limit: 4, wavelength: 850, lengthlimit: 275, losslimit: 2.6},
      {limit: 5, wavelength: 1300, lengthlimit: 300, losslimit: 2.5},
   ] }, // OM2

   { key: 2, value: [
      {limit: 0, wavelength: 0, lengthlimit: 0, losslimit: 0},
      {limit: 1, wavelength: 0, lengthlimit: 0, losslimit: 0},
      {limit: 2, wavelength: 1300, lengthlimit: 2000, losslimit: 6.0},
      {limit: 3, wavelength: 1300, lengthlimit: 550, losslimit: 2.3},
      {limit: 5, wavelength: 1300, lengthlimit: 300, losslimit: 2.0},
      {limit: 8, wavelength: 850, lengthlimit: 300, losslimit: 2.6},
      {limit: 10, wavelength: 850, lengthlimit: 100, losslimit: 1.9},
      {limit: 12, wavelength: 850, lengthlimit: 70, losslimit: 1.9},
      {limit: 13, wavelength: 850, lengthlimit: 100, losslimit: 1.9},
   ] }, // OM3

   { key: 3, value: [
      {limit: 0, wavelength: 0, lengthlimit: 0, losslimit: 0},
      {limit: 1, wavelength: 0, lengthlimit: 0, losslimit: 0},
      {limit: 2, wavelength: 1300, lengthlimit: 2000, losslimit: 6.0},
      {limit: 3, wavelength: 1300, lengthlimit: 550, losslimit: 2.3},
      {limit: 5, wavelength: 1300, lengthlimit: 300, losslimit: 2.0},
      {limit: 8, wavelength: 850, lengthlimit: 400, losslimit: 2.9},
      {limit: 10, wavelength: 850, lengthlimit: 150, losslimit: 1.5},
      {limit: 12, wavelength: 850, lengthlimit: 100, losslimit: 1.9},
      {limit: 13, wavelength: 850, lengthlimit: 150, losslimit: 1.5},
   ] }, // OM4

   { key: 4, value: [
      {limit: 0, wavelength: 0, lengthlimit: 0, losslimit: 0},
      {limit: 1, wavelength: 0, lengthlimit: 0, losslimit: 0},
      {limit: 2, wavelength: 1300, lengthlimit: 2000, losslimit: 6.0},
      {limit: 3, wavelength: 1300, lengthlimit: 550, losslimit: 2.3},
      {limit: 5, wavelength: 1300, lengthlimit: 300, losslimit: 2.0},
      {limit: 8, wavelength: 850, lengthlimit: 400, losslimit: 2.9},
      {limit: 10, wavelength: 850, lengthlimit: 150, losslimit: 1.5},
      {limit: 12, wavelength: 850, lengthlimit: 100, losslimit: 1.9},
      {limit: 13, wavelength: 850, lengthlimit: 150, losslimit: 1.5},
   ] }, // OM5

   { key: 5, value: [
      {limit: 0, wavelength: 0, lengthlimit: 0, losslimit: 0},
      {limit: 1, wavelength: 0, lengthlimit: 0, losslimit: 0},
      {limit: 3, wavelength: 1310, lengthlimit: 5000, losslimit: 4.5},
      {limit: 15, wavelength: 1310, lengthlimit: 10000, losslimit: 7.5},
      {limit: 14, wavelength: 1310, lengthlimit: 40000, losslimit: 18.0},
      {limit: 16, wavelength: 1550, lengthlimit: 70000, losslimit: 21.0},
      {limit: 5, wavelength: 1310, lengthlimit: 10000, losslimit: 6.3},
      {limit: 6, wavelength: 1550, lengthlimit: 40000, losslimit: 11.0},
      {limit: 7, wavelength: 1310, lengthlimit: 10000, losslimit: 6.2},
      {limit: 9, wavelength: 1310, lengthlimit: 10000, losslimit: 6.7},
      {limit: 11, wavelength: 1310, lengthlimit: 10000, losslimit: 6.3},
   ] }, // OS1

   { key: 6, value: [
      {limit: 0, wavelength: 0, lengthlimit: 0, losslimit: 0},
      {limit: 1, wavelength: 0, lengthlimit: 0, losslimit: 0},
      {limit: 3, wavelength: 1310, lengthlimit: 5000, losslimit: 4.5},
      {limit: 15, wavelength: 1310, lengthlimit: 10000, losslimit: 7.5},
      {limit: 14, wavelength: 1310, lengthlimit: 40000, losslimit: 18.0},
      {limit: 16, wavelength: 1550, lengthlimit: 70000, losslimit: 21.0},
      {limit: 5, wavelength: 1310, lengthlimit: 10000, losslimit: 6.3},
      {limit: 6, wavelength: 1550, lengthlimit: 40000, losslimit: 11.0},
      {limit: 7, wavelength: 1310, lengthlimit: 10000, losslimit: 6.2},
      {limit: 9, wavelength: 1310, lengthlimit: 10000, losslimit: 6.7},
      {limit: 11, wavelength: 1310, lengthlimit: 10000, losslimit: 6.3},
   ] }, // OS2
]

};



// WEBPACK FOOTER //
// ./src/components/subtestsetting/fiberlengthloss/fiberlengthlossenum.js